export default __webpack_public_path__ + "static/Logo50-a7f2d763f8b9b48b3d14efcc97e92acf.png";